module.exports={
	"Form": "AssetTypeEditManifest",
	"Scope": "AssetType-Edit",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-Edit-Identity",
				"Group": "AssetType-Edit-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-Edit-Details",
				"Group": "AssetType-Edit-Details"
			}
		},
		"AssetTypeDetails.IDAssetType":
		{
			"Name": "IDAsset Type",
			"Hash": "AssetType-Edit-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.GUIDAssetType":
		{
			"Name": "GUIDAsset Type",
			"Hash": "AssetType-Edit-GUIDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
